// utils/errorLogger/user.ts - utils/errorLogger.ts split (sub-module user)

// Direct import (BUKAN barrel '../../supabase'): barrel menarik pool/retry/queue
// + offlineStorage/connectionPool ke entry publik (chunk contexts-admin 72KB).
import { supabase } from '../../supabase/client';
import { getSessionUser } from '../../supabase/sessionUser';


/**
 * Get current user info from Supabase session
 */
export const getCurrentUserInfo = async (): Promise<{
    userId: string | null;
    userEmail: string | null;
    userRole: string | null;
}> => {
    try {
        const user = await getSessionUser();

        if (!user) {
            return { userId: null, userEmail: null, userRole: null };
        }

        // Get user role from users table
        const { data: userData } = await supabase
            .from('users')
            .select('role')
            .eq('id', user.id)
            .single();

        return {
            userId: user.id,
            userEmail: user.email || null,
            userRole: userData?.role || null
        };
    } catch {
        return { userId: null, userEmail: null, userRole: null };
    }
};
